export const validatePersonName = (name?: string) => {
    return (name?.trim() ?? "").length >= 2 && !!/^[a-zA-ZÄäÖöÜüÕõŽžŠš '-]{2,40}$/.exec(name ?? "");
};

export const validateRegistryCode = (code?: string) => {
    return !!/^\d{8}$/.exec(code ?? "");
};

export const validateInteger = (value: undefined | number | string, minValue: number) => {
    if (value === undefined || value === "" || value === null) {
        return false;
    }

    const floatVal = Number.parseFloat(String(value));
    return !Number.isNaN(floatVal) && floatVal >= minValue && Number.isInteger(floatVal);
};

const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

export const isValidEmail = (email: string | undefined) => {
    return !!email && emailReg.test(email);
};

const pwReg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[^\w\s]).{15,}$/;

export const isStrongPassword = (pw: string) => {
    return !!pw && pwReg.test(pw);
};

const addressPattern = /^[A-Za-z0-9ÄäÖöÜüÕõŽžŠš\s,.'-]{5,100}$/;

export const isValidAddressFormat = (address: string) => {
    return !!address && addressPattern.test(address);
};